import Component from './client-select';

export default Component;

export {ClientSelectModal} from './client-select-modal';
